// Core
import React from 'react'
import { Switch, Route, Redirect, useLocation } from 'react-router-dom'

// Library
// @ts-expect-error there is no types for product-fruits
import ProductFruits from 'react-product-fruits'

// Routes
import routes from 'routes'

// Pages
import ProfilePriorities from 'pages/Onboarding/Profile/Priorities'
import ProfileBusiness from 'pages/Onboarding/Profile/Business'
import Usage from 'pages/Onboarding/Usage'
import OnboardingConnectPage from 'pages/Onboarding/Connect'
import CompanyDetails from 'pages/Onboarding/Profile/Company'

// Hooks
import { useAppSelector } from 'state-manager/store'

// Constants
import { ENV } from 'constants/main'
import { PRODUCT_FRUITS_KEYS } from 'constants/productfruits'
import { PRIORITY_VALUES } from 'pages/Onboarding/Profile/Priorities/constants'

const ConnectThirdPartyServices = () => {
  const onboardingInfoLocalStorage = localStorage.getItem('onboarding_pf')
  const onboardingInfo = onboardingInfoLocalStorage != null ? JSON.parse(onboardingInfoLocalStorage) : {}
  const userData = useAppSelector((state) => state.userData)
  const {
    id: userID,
    email,
    firstName: firstname,
    lastName: lastname,
  } = userData
  const signUpAt = userData.createdAt ?? null
  const username = userID?.toString()
  const customProps = {
    [PRODUCT_FRUITS_KEYS.BUSINESS_TYPE]: onboardingInfo['business_type'] || '',
    [PRODUCT_FRUITS_KEYS.PRIORITY_AUTOMATION]: onboardingInfo['priorities']?.includes(PRIORITY_VALUES.AUTOMATION) ? 'yes' : 'no',
    [PRODUCT_FRUITS_KEYS.PRIORITY_OVERSPEND]: onboardingInfo['priorities']?.includes(PRIORITY_VALUES.OVERSPEND) ? 'yes' : 'no',
    [PRODUCT_FRUITS_KEYS.PRIORITY_PACING]: onboardingInfo['priorities']?.includes(PRIORITY_VALUES.REPORTING) ? 'yes' : 'no',
    [PRODUCT_FRUITS_KEYS.PRIORITY_PERFORMANCE]: onboardingInfo['priorities']?.includes(PRIORITY_VALUES.PERFORMANCE) ? 'yes' : 'no',
  }

  return (
    <ProductFruits
      projectCode={process.env.REACT_APP_PF_KEY}
      language="en"
      username={username}
      email={email}
      firstname={firstname}
      lastname={lastname}
      signUpAt={signUpAt}
      props={customProps}
    />
  )
}

const OnboardingAccess = () => {
  const location = useLocation()
  const udIsAuthorized = useAppSelector((state) => state.userData.isAuthorized)
  const isLocalEnvironment = ENV === 'local' 

  return (
    <Route
      render={() => {
        if (!udIsAuthorized) {
          return (
            <Redirect to={{ pathname: routes.modalSignIn[0], state: { from: location.pathname } }} />
          )
        }
        return (
          <>
            {!isLocalEnvironment && <ConnectThirdPartyServices />}
            <Switch>
              <Route exact path={routes.onboardingProfileBusiness} component={ProfileBusiness} />
              <Route exact path={routes.onboardingProfilePriorities} component={ProfilePriorities} />
              <Route exact path={routes.onboardingUsage} component={Usage} />
              <Route exact path={routes.onboardingConnect} component={OnboardingConnectPage} />
              <Route exact path={routes.onboardingCompanyDetails} component={CompanyDetails} />
              <Redirect to={{ pathname: routes.modalSignIn[0], state: { from: location.pathname } }} />
            </Switch>
          </>
        )
      }}
    />
  )
}

export default OnboardingAccess
